module.exports = __webpack_public_path__ + "static/media/step-2.86c8b994.png";